import { Link } from 'react-router-dom'
import { AlertTriangle, Bot, ShieldCheck } from 'lucide-react'

// Módulo planejado — nada aqui está funcionando ainda.
export default function ChatbotPage() {
  return (
    <div>
      <header style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div
            aria-hidden
            style={{
              width: 38, height: 38, borderRadius: 10, background: 'var(--primary-soft)',
              color: 'var(--primary-deep)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <Bot size={19} />
          </div>
          <div>
            <h1 className="page-title">Chatbot</h1>
            <p className="page-subtitle" style={{ margin: 0 }}>Triagem automática antes de chegar na equipe.</p>
          </div>
        </div>
      </header>

      <div className="badge badge-warn" style={{ display: 'block', padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>
        <AlertTriangle size={13} aria-hidden /> Módulo ainda não implementado — esta tela descreve o fluxo previsto.
      </div>

      <section className="card" style={{ padding: 18, marginBottom: 14 }}>
        <strong style={{ fontSize: 15, display: 'block', marginBottom: 8 }}>Fluxo previsto</strong>
        <ol style={{ margin: 0, paddingLeft: 18, lineHeight: 1.9, fontSize: 14, color: 'var(--text-secondary)' }}>
          <li>Paciente manda mensagem no WhatsApp do consultório.</li>
          <li>O bot dá boas-vindas e pergunta o motivo (agendar, exame, receita, dúvida, outro).</li>
          <li>Classifica a conversa na categoria certa e identifica a paciente pelo telefone.</li>
          <li>Resolve o que é objetivo (endereço, horário de funcionamento, orientação de preparo).</li>
          <li><strong>Entrega para a equipe</strong> tudo que for clínico, urgente ou fora do roteiro.</li>
        </ol>
      </section>

      <section className="card" style={{ padding: 18, marginBottom: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <ShieldCheck size={17} aria-hidden style={{ color: 'var(--ok)' }} />
          <strong style={{ fontSize: 15 }}>Regras de segurança</strong>
        </div>
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8, fontSize: 14, color: 'var(--text-secondary)' }}>
          <li>O bot <strong>nunca dá orientação clínica</strong> nem interpreta sintoma, exame ou medicação.</li>
          <li>Ao detectar urgência ou intercorrência, escala imediatamente para uma pessoa.</li>
          <li><strong>Nunca encerra a conversa sozinho</strong>: quem encerra é a equipe.</li>
          <li>Toda mensagem do bot fica marcada como automática no histórico da conversa.</li>
        </ul>
      </section>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Link to="/atendimento" className="btn-secondary">Ir para a caixa de entrada</Link>
        <Link to="/configuracoes/whatsapp" className="btn-secondary">Configurações do WhatsApp</Link>
      </div>
    </div>
  )
}
